// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const buneary: PokeData = {
  "id": 427,
  "name": "buneary",
  "height": 4,
  "weight": 55,
  "base_experience": 70,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "double-kick",
    "jump-kick",
    "headbutt",
    "double-edge",
    "agility",
    "quick-attack",
    "defense-curl",
    "swift",
    "dizzy-punch",
    "splash",
    "foresight",
    "endure",
    "charm",
    "frustration",
    "baton-pass",
    "flatter",
    "bounce",
    "healing-wish",
    "double-hit",
    "entrainment",
    "after-you",
    "draining-kiss",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "double-kick",
    "jump-kick",
    "headbutt",
    "quick-attack",
    "splash",
    "flatter",
    "healing-wish",
    "play-rough",
    "supersonic",
    "growl",
    "body-slam",
    "leer",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 220,
    "item": null,
    "species": [
      {
        "name": "buneary",
        "order": 454,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lopunny",
        "order": 455,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 427,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 85,
    "ability_power": 66
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
